import React from 'react'
import axios from "axios";
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ROUTES from '../../Nav/Routes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EventList = () => {
    const [listOfEvents, setListOfEvents] = useState([]);
    const [currentId, setCurrentId] = useState("");
    const notifyDelete = () => toast("Item Deleted Successfully!", {
        hideProgressBar: false,
        pauseOnHover: false,
        hideProgressBar: true,
        style: {
            style: {
                color: '#008000',
            }
        }
    });

    useEffect(() => {
        axios.get("https://bntserver.bntfoundation.com/EventGet.php").then((response) => {
            setListOfEvents(response.data);
        })
    }, [])

    let navigate = useNavigate();

    const deleteEvent = () => {
        axios.delete(`https://bntserver.bntfoundation.com/EventDelete.php?id=${currentId}`).then(() => {
            setListOfEvents(listOfEvents.filter(function (item) {
                return item.id !== currentId;
            }))
        }).then(() => {
            hideDeleteModal();
            notifyDelete();
        })
    }

    const showDeleteModal = (EventId) => {
        document.getElementById("deleteModal").style.display = "block";
        setCurrentId(EventId);
    }

    const hideDeleteModal = () => {
        document.getElementById("deleteModal").style.display = "none";
    }

    return (
        <div className='w-100'>
            <div className="modal" id='deleteModal'>
                <div className="modal-dialog shadow-box" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={hideDeleteModal}>
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body text-dark">
                            <p>Are you sure you want to delete?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger mx-3" onClick={deleteEvent}>Yes</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={hideDeleteModal}>No</button>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />

            <h2>Event List</h2>
            <p>
                <Link title="Add New Event" to={ROUTES.addevent.name}>Add New Event</Link>
            </p>
            <table className="table">
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Event Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {listOfEvents.map((value, key) => {
                        const eventDate = new Date(value.eventdate);
                        const options = { day: 'numeric', month: 'long', year: 'numeric' };
                        const formattedDate = eventDate.toLocaleDateString('en-CA', options);
                        return (
                            <tr key={key}>
                                <td>
                                    <img src={`https://bntserver.bntfoundation.com/${value.image}`} width="100px" style={{ padding: "0px" }} alt={value.title} />
                                </td>
                                <td>{value.title}</td>
                                <td>{value.desc}</td>
                                <td>{formattedDate}</td>
                                <td>
                                    <div className='text-primary d-inline onHover' onClick={() => navigate(`/editevent/${value.id}`)}>Edit</div>
                                    <div className='text-danger d-inline onHover' onClick={() => showDeleteModal(value.id)}>Delete</div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default EventList; 